<template>
    <div class="dashboard-grid-page admin">
        <NavBarPP :isAdmin="true">
            <template v-slot:left-items-logged>
                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'DashboardAdminPage' }">Dashboard</router-link>
                </li>
            </template>

            <template v-slot:items-link-logged>
                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'InvestorsAdminPage' }">
                        Investidores
                    </router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'InitiativesAdminPage' }">
                        Iniciativas
                    </router-link>
                </li>

                <li :class="'nav-item'">
                    <router-link class="nav-link" :to="{ name: 'SupportersAdminPage' }">
                        Prestadores de serviço
                    </router-link>
                </li>

                <!-- <li :class="'nav-item'">
                    <router-link class="nav-link" to="#">Relatórios</router-link>
                </li> -->

                <li :class="'nav-item'">
                    <b-nav-item-dropdown text="Configurações">
                        <b-dropdown-item router-link :to="{ name: 'EditPagesAdmin' }">
                            <i class="far fa-file"></i>
                            Editar páginas
                        </b-dropdown-item>

                        <b-dropdown-item router-link :to="{ name: 'UsersAdminPage' }">
                            <i class="fas fa-user-friends"></i>
                            Usuários
                        </b-dropdown-item>
                    </b-nav-item-dropdown>
                </li>
            </template>

            <template v-slot:right-buttons-logged>
                <span class="navbar-text">
                    <li :class="'nav-item'">
                        <button class="btn btn-default">
                            <i class="far fa-bell"></i>
                        </button>
                    </li>

                    <li :class="'nav-item profile-options'">
                        <b-nav-item-dropdown :text="usuario.name">
                            <b-dropdown-item router-link v-b-toggle.sidebar-my-profile @click="openSidebarMyProfile()">
                                <b-icon icon="person"></b-icon>
                                Meu Perfil
                            </b-dropdown-item>
                            <b-dropdown-item router-link v-b-toggle.sidebar-update-pwd @click="openSidebarUpdatePwd()">
                                <b-icon icon="unlock"></b-icon>
                                Alterar Senha
                            </b-dropdown-item>
                            <b-dropdown-item @click="logout()">
                                <b-icon icon="box-arrow-right"></b-icon>
                                Sair
                            </b-dropdown-item>
                        </b-nav-item-dropdown>
                    </li>
                </span>
            </template>
        </NavBarPP>

        <div class="dashboard-grid-page-body">
            <router-view></router-view>
        </div>

        <!-- <FooterPP /> -->

        <b-sidebar id="sidebar-my-profile" :title="'Meu perfil'" backdrop shadow right>
            <div>
                <b-form @submit.stop.prevent="myProfileSubmit" novalidate>
                    <b-form-group label="Nome" label-for="name" class="required">
                        <b-form-input
                            id="name"
                            name="name"
                            v-model="$v.myProfilerForm.name.$model"
                            type="text"
                            placeholder="Digite nome"
                            :state="validateStateMyProfile('name')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateMyProfile('name')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="E-mail" label-for="email" class="required">
                        <b-form-input
                            id="email"
                            name="email"
                            v-model="$v.myProfilerForm.email.$model"
                            type="text"
                            placeholder="Digite e-mail"
                            :state="validateStateMyProfile('email')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateMyProfile('email')">
                            <div v-if="!$v.myProfilerForm.email.required">Campo obrigatório</div>
                            <div v-if="!$v.myProfilerForm.email.email">Escreva um e-mail válido</div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="CPF" label-for="cpf" class="required">
                        <b-form-input
                            id="cpf"
                            name="cpf"
                            v-model="$v.myProfilerForm.cpf.$model"
                            v-mask="'###.###.###-##'"
                            placeholder="Digite CPF"
                            disabled
                            :state="validateStateMyProfile('cpf')"
                        ></b-form-input>

                        <b-form-invalid-feedback :state="validateStateMyProfile('cpf')">
                            <div v-if="!$v.myProfilerForm.cpf.required">
                                Campo obrigatório
                            </div>

                            <div v-if="!$v.myProfilerForm.cpf.minLength">
                                Deve conter 14 caracteres
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="!getIsDarkTheme ? 'dark' : 'primary'" class="radius-6 submit">
                        Salvar
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-sidebar id="sidebar-update-pwd" :title="'Alterar senha'" backdrop shadow right>
            <div>
                <b-form @submit.stop.prevent="updatePwdSubmit" novalidate>
                    <b-form-group label="Senha atual" label-for="currentPassword" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="currentPassword"
                                v-model="$v.updatePwdForm.currentPassword.$model"
                                :type="showCurrentPassword ? 'text' : 'password'"
                                placeholder="Digite senha atual"
                                :state="validateStateUpdatePwd('currentPassword')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showCurrentPassword = !showCurrentPassword">
                                    <i :class="`fas fa-${showCurrentPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('currentPassword')">
                            Campo obrigatório
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Nova senha" label-for="password" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="password"
                                v-model="$v.updatePwdForm.password.$model"
                                :type="showPassword ? 'text' : 'password'"
                                placeholder="Digite uma nova senha"
                                :state="validateStateUpdatePwd('password')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showPassword = !showPassword">
                                    <i :class="`fas fa-${showPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('password')">
                            <div v-if="!$v.updatePwdForm.password.required">
                                Campo obrigatório
                            </div>

                            <div v-if="!$v.updatePwdForm.password.minLength">
                                Deve conter no mínimo 8 caracteres
                            </div>

                            <div v-if="!$v.updatePwdForm.password.containsUppercase">
                                Deve conter no mínimo 1 letra maiúscula
                            </div>

                            <div v-if="!$v.updatePwdForm.password.containsNumber">
                                Deve conter no mínimo 1 número
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-form-group label="Confirmar senha" label-for="confirmPassword" class="password-field">
                        <b-input-group>
                            <b-form-input
                                id="confirm-password"
                                v-model="$v.updatePwdForm.confirmPassword.$model"
                                :type="showConfirmPassword ? 'text' : 'password'"
                                placeholder="Digite novamente sua senha"
                                :state="validateStateUpdatePwd('confirmPassword')"
                            >
                            </b-form-input>
                            <b-input-group-append class="btn-eye-password">
                                <b-button class="btn" @click="showConfirmPassword = !showConfirmPassword">
                                    <i :class="`fas fa-${showConfirmPassword ? 'eye' : 'eye-slash'}`"></i>
                                </b-button>
                            </b-input-group-append>
                        </b-input-group>

                        <b-form-invalid-feedback :state="validateStateUpdatePwd('confirmPassword')">
                            <div v-if="!$v.updatePwdForm.confirmPassword.required">
                                Campo obrigatório
                            </div>
                            <div
                                v-if="!$v.updatePwdForm.confirmPassword.sameAsPassword && updatePwdForm.confirmPassword"
                            >
                                Senhas devem ser iguais
                            </div>
                        </b-form-invalid-feedback>
                    </b-form-group>

                    <b-button type="submit" :variant="!getIsDarkTheme ? 'dark' : 'primary'" class="radius-6 submit">
                        Salvar
                    </b-button>
                </b-form>
            </div>
        </b-sidebar>

        <b-modal
            ref="success-modal-ref"
            :hide-header="true"
            :hide-footer="true"
            body-class="warning-modal"
            :modal-class="getIsDarkTheme ? 'dark-theme' : ''"
            :no-close-on-backdrop="true"
        >
            <div class="content">
                <SuccessMsgModal :msg="message" />
            </div>

            <div class="footer-buttons">
                <b-button variant="primary" @click="hideModal('success-modal-ref')">Entendi</b-button>
            </div>
        </b-modal>

        <DangerModalPP ref="warningModal" :message="message" />
    </div>
</template>

<script>
import { mapActions } from 'vuex'
import { required, email, sameAs, minLength } from 'vuelidate/lib/validators'
import NavBarPP from '@/ui/navbar-pp/NavBarPP'
import FooterPP from '@/ui/footer-pp/FooterPP'
import SuccessMsgModal from '@/ui/modal/success-msg-modal/SuccessMsgModal'
import DangerMsgModal from '@/ui/modal/danger-msg-modal/DangerMsgModal'
import DangerModalPP from '@/ui/modal/danger-modal-pp/DangerModalPP'
import { AuthenticationApi } from './../../../api/authentication'
import { DashboardAdminApi } from './../../../api/dashboard-admin-api'

const authenticationApi = new AuthenticationApi()
const dashboardAdminApi = new DashboardAdminApi()

export default {
    components: { NavBarPP, FooterPP, SuccessMsgModal, DangerMsgModal, DangerModalPP },
    data() {
        return {
            usuario: {},
            message: null,
            errorModal: false,
            showCurrentPassword: false,
            showPassword: false,
            showConfirmPassword: false,
            myProfilerForm: {
                name: null,
                email: null,
                cpf: null
            },
            updatePwdForm: {
                currentPassword: null,
                password: null,
                confirmPassword: null
            }
        }
    },
    validations: {
        myProfilerForm: {
            name: { required },
            email: { required, email },
            cpf: { required, minLength: minLength(14) }
        },
        updatePwdForm: {
            currentPassword: { required },
            password: {
                required,
                minLength: minLength(8),
                containsUppercase: function(value) {
                    return /[A-Z]/.test(value)
                },
                containsNumber: function(value) {
                    return /[0-9]/.test(value)
                }
            },
            confirmPassword: {
                required,
                sameAsPassword: sameAs('password')
            }
        }
    },
    computed: {
        getIsDarkTheme() {
            return this.$store.state.darkTheme
        }
    },
    methods: {
        ...mapActions(['setIsLoading', 'setStatusProfileUserAdm']),
        validateStateMyProfile(nameField) {
            const { $dirty, $error } = this.$v.myProfilerForm[nameField]
            return $dirty ? !$error : null
        },
        validateStateUpdatePwd(nameField) {
            const { $dirty, $error } = this.$v.updatePwdForm[nameField]
            return $dirty ? !$error : null
        },
        fetch() {
            this.setIsLoading(true)

            dashboardAdminApi
                .getCurrentUser()
                .then(response => {
                    if (response.data.result !== null) {
                        const data = response.data.result[0]
                        this.usuario = data
                        this.setStatusProfileUserAdm(data.id_permissao)
                        this.myProfilerForm.name = data.name
                        this.myProfilerForm.email = data.email
                        this.myProfilerForm.cpf = data.cpf
                    }
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        myProfileSubmit(event) {
            this.$v.myProfilerForm.$touch()

            if (this.$v.myProfilerForm.$anyError) {
                return null
            }

            this.setIsLoading(true)

            authenticationApi
                .updateProfile(this.myProfilerForm)
                .then(response => {
                    this.message = 'Perfil alterado com sucesso!'
                    this.usuario.name = this.myProfilerForm.name
                    this.closeSidebarMyProfile()
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        updatePwdSubmit(event) {
            this.$v.updatePwdForm.$touch()

            if (this.$v.updatePwdForm.$anyError) {
                return null
            }

            this.setIsLoading(true)

            const data = {
                password_atual: this.updatePwdForm.currentPassword,
                password: this.updatePwdForm.password,
                password_confirmation: this.updatePwdForm.confirmPassword
            }

            authenticationApi
                .changePassword(data)
                .then(response => {
                    this.message = 'Senha alterada com sucesso!'
                    this.closeSidebarUpdatePwd()
                    this.showModal('success-modal-ref')
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        },
        openSidebarMyProfile() {
            this.$v.myProfilerForm.$reset()
        },
        openSidebarUpdatePwd() {
            this.$v.updatePwdForm.$reset()
            this.showPassword = false
            this.showConfirmPassword = false
            this.showCurrentPassword = false
            this.updatePwdForm.password = null
            this.updatePwdForm.confirmPassword = null
            this.updatePwdForm.currentPassword = null
        },
        closeSidebarMyProfile() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-my-profile')
        },
        closeSidebarUpdatePwd() {
            this.$root.$emit('bv::toggle::collapse', 'sidebar-update-pwd')
        },
        showModal(refModalName) {
            this.$refs[refModalName].show()
        },
        hideModal(refModalName) {
            this.$refs[refModalName].hide()
        },
        logout() {
            this.setIsLoading(true)

            authenticationApi
                .logout()
                .then(response => {
                    localStorage.clear()
                    this.$router.push({ name: 'LoginAdminForm' })
                })
                .catch(error => {
                    this.message = error.response.data.message
                    this.$refs.warningModal.showModal()
                })
                .finally(() => {
                    this.setIsLoading(false)
                })
        }
    },
    created() {
        this.fetch()
    }
}
</script>

<style scope src="../dashboard-page/DashboardGridPage-light-theme.css"></style>
<style scope src="../dashboard-page/DashboardGridPage-dark-theme.css"></style>
<style scope src="./DashboardAdminGridPage-light-theme.css"></style>
<style scope src="./DashboardAdminGridPage-dark-theme.css"></style>



// WEBPACK FOOTER //
// src/pages/private/dashboard-admin-grid-page/DashboardAdminGridPage.vue